import template from './index.html'
import ko from 'knockout'
function init ({placeholder, data, minDate, maxDate, numbericValue, position, disabled, fieldid}) {
  this.placeholder = placeholder
  this.data = data
  this.disabled = disabled
  this.position = position
  this.minDate = minDate || ko.observable('1600-01-01')
  this.maxDate = maxDate || ko.observable('2099-12-31')
  this.numbericValue = numbericValue
  this.fieldid = fieldid || this.data._fieldid || ''
}
export default {
  name: 'datetimepicker',
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/datetimepicker/index.js